import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import { Box } from "@material-ui/core";
import useEnv from "../../../hooks/env";
import TestRequestHistoryApi from "../../../api/services/TestRequestHistoryApi";
import RequestsPagePathParams from "../../../api/models/test-request/RequestsPagePathParams";
import ErrorSnackbarContext from "../../../contexts/ErrorSnackbarContext";
import TestRequestPermissionContext from "../../../contexts/TestRequestPermissionContext";
import CustomFooterGraphic from "../CustomFooterGraphic";
import CustomTable from "../../../components/CustomTable";
import HistoryEntry from "./models/HistoryEntry.model";
import mapHistoryEntry from "./models/mapHistoryEntry.function";
import CustomProgress from "../../../components/Alert/CustomProgress";
import readAbbreviatedTimeZone from "../../../functions/readAbbreviatedTimeZone.function";

const HistoryTab: React.FC<unknown> = () => {
  const { testRequestId } = useParams<RequestsPagePathParams>();
  const { api } = useEnv();
  const testRequestHistoryApi = new TestRequestHistoryApi(api);
  const { handleHttpError } = useContext(ErrorSnackbarContext);
  const { accessDescription } = useContext(TestRequestPermissionContext);

  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState<HistoryEntry[]>([]);
  const timeZoneAbbreviation = readAbbreviatedTimeZone();
  const timeZoneAbbreviationSuffix = timeZoneAbbreviation ? ` (${timeZoneAbbreviation})` : "";

  const springProps = useSpring({
    opacity: history.length ? 1 : 0,
  });

  useEffect(() => {
    setLoading(true);
    testRequestHistoryApi
      .fetchTestRequestHistory(testRequestId)
      .then((response) => response.data.map(mapHistoryEntry))
      .then(setHistory)
      .catch(handleHttpError)
      .finally(() => setLoading(false));
  }, []);

  const render = () => {
    if (!accessDescription) {
      return "Access denied.";
    }
    if (loading) {
      return <CustomProgress />;
    }
    return (
      <Box>
        <CustomTable
          columnMaxWidths={["", "100px", "", "30px", "30px"]}
          columnExactWidths={["160px", "", "160px", "", ""]}
          columns={[`Date${timeZoneAbbreviationSuffix}`, "Action", "Test Request Status", "Actor", "Lab"]}
          rows={history}
        />
        <CustomFooterGraphic />
      </Box>
    );
  };

  return <animated.div style={springProps}>{render()}</animated.div>;
};

export default HistoryTab;
